import { render } from "./filterTabItem.vue?vue&type=template&id=398dc551"
import script from "./filterTabItem.vue?vue&type=script&lang=js"
export * from "./filterTabItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./filterTabItem.vue?vue&type=style&index=0&id=398dc551&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__